import { useEffect, useRef } from 'react';
import Echo from 'laravel-echo';
import { createEcho } from './useChatEcho';

export type CommentMutation = {
    action: 'created' | 'updated' | 'deleted';
    post_id?: number;
    reel_id?: number;
    comment: any;
};

export function useCommentEcho({
    token,
    postId,
    reelId,
    onComment,
}: {
    token: string | undefined | null;
    postId?: number | null;
    reelId?: number | null;
    onComment: (mutation: CommentMutation) => void;
}) {
    const callbackRef = useRef(onComment);
    callbackRef.current = onComment;

    useEffect(() => {
        if (!token || (!postId && !reelId)) return;
        const echo: Echo<"reverb"> = createEcho(token);
        const resource = postId ? `post-comments.${postId}` : `reel-comments.${reelId}`;
        echo.channel(resource).listen('.CommentUpdated', (payload: CommentMutation) => callbackRef.current(payload));

        return () => {
            echo.leave(resource);
            echo.disconnect();
        };
    }, [token, postId, reelId]);
}
